var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcLock = function SvgIcLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "34px",
    viewBox: "0 0 31 34",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_lock")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_lock",
    fill: "#697287",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.16,
    cy: 20.64,
    r: 1.68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,8 C24.5090437,3.26530868 20.1188949,0.045095167 15.155,0.045095167 C10.1911051,0.045095167 5.80095633,3.26530868 4.31,8 C1.8336582,8.41353215 0.0143645773,10.5494082 0,13.06 L0,28.53 C-5.33395338e-06,31.3814115 2.30859387,33.6944847 5.16,33.7 L25.16,33.7 C28.0130298,33.6944975 30.3244975,31.3830298 30.33,28.53 L30.33,13.06 C30.3139876,10.5429995 28.4842838,8.40482363 26,8 Z M27.8,28.53 C27.8,29.2301715 27.5218579,29.9016659 27.0267619,30.3967619 C26.5316659,30.8918579 25.8601715,31.17 25.16,31.17 L5.16,31.17 C3.70587502,31.1644919 2.52998957,29.9841354 2.53,28.53 L2.53,13.06 C2.52998957,11.6058646 3.70587502,10.4255081 5.16,10.42 L6.31,10.42 L6.53,9.42 C7.44562578,5.39054087 11.02782,2.53102014 15.16,2.53102014 C19.29218,2.53102014 22.8743742,5.39054087 23.79,9.42 L24.01,10.42 L25.16,10.42 C26.6180317,10.42 27.8,11.6019683 27.8,13.06 L27.8,28.53 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.16,4.63 C11.9054259,4.63551624 9.26999533,7.27542123 9.27,10.53 L21.06,10.53 C21.06,8.96522271 20.4383946,7.46453462 19.33193,6.35806999 C18.2254654,5.25160536 16.7247773,4.63 15.16,4.63 Z",
    id: "Path"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_lock.4c74a264.svg";
export { ForwardRef as ReactComponent };